import isInIframe from '@anm/helpers/is/isInIframe';
import useIsMountedCheck from '@anm/hooks/useIsMountedCheck';
import { useEffect, useRef, useState } from 'react';

export const useBrokenPlayerSize = () => {
  const isIframe = isInIframe();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isMounted = useIsMountedCheck();
  const [wrapperHeight, setWrapperHeight] = useState<number>();

  useEffect(() => {
    if (!wrapperRef.current || !isIframe || !isMounted) return;

    const height = wrapperRef.current.closest('html')?.offsetHeight;

    height && setWrapperHeight(height);
  }, [wrapperRef.current]);

  return [wrapperHeight, wrapperRef] as const;
};
